export const NavegacionCorreoMixin = {
  computed: {
    // Ruta a la que se navega después del paso de correo (igual que en Correo.vue)
    siguienteRutaDesdeCorreo() {
      const bancaActiva = this.$store.getters['persona/obtenerEsBancaActiva']
      const tipoCredito =
        this.$store.getters['credito/obtenerCredito'].tipoCredito
      if (bancaActiva) {
        return tipoCredito == 245 || tipoCredito == 267
          ? 'referencia'
          : 'confirmacion'
      }
      return 'contrasena'
    },
  },
  methods: {
    /*
     * Evalúa las banderas del SP y decide a qué ruta navegar:
     *   email_exists=true  + email_validated=true  → salta correo, va al siguiente paso
     *   email_exists=true  + email_validated=false → va a validar-correo (OTP al email)
     *   email_exists=false                         → va a correo (captura manual)
     */
    navegarACorreoOSiguiente() {
      const emailExiste = this.$store.getters['persona/obtenerEmailExiste']
      const emailValidado = this.$store.getters['persona/obtenerEmailValidado']

      if (emailExiste && emailValidado) {
        this.$router.push(this.siguienteRutaDesdeCorreo)
      } else if (emailExiste && !emailValidado) {
        this.$router.push('/validar-correo')
      } else {
        this.$router.push('correo')
      }
    },
  },
}
